/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {GaugeDefaults as ɵb} from './gauge-defaults.service';
export {GaugeComponent as ɵa} from './gauge.component';